// Central reducer for augment effects
import { AugmentIds } from './catalog';

// store adapter contract:
// - getAugmentId(unitId) => string | null
// - addGold(n)
// - getRuntime(unitId) => object (mutable)
// - queueBenchNextRound(pieceType)
// - isKingUnit(unitId) => boolean
// - getPieceType(unitId) => 'p'|'n'|'b'|'r'|'q'|'k'

export function applyAugments(store, event) {
  if (!event || !store) return;
  switch (event.type) {
    case 'onMove': {
      const aug = store.getAugmentId(event.unitId);
      if (aug === AugmentIds.PATHFINDER) {
        const rt = store.getRuntime(event.unitId);
        const tiles = manhattan(event.from, event.to);
        rt.tilesMoved = (rt.tilesMoved || 0) + tiles;
      }
      break;
    }
    case 'onCapture': {
      const aug = store.getAugmentId(event.attackerUnitId);
      if (!aug) break;
      if (aug === AugmentIds.BOUNTY_HUNTER) {
        const rt = store.getRuntime(event.attackerUnitId);
        const current = rt.bountyPending || 0;
        rt.bountyPending = Math.min(2, current + 1);
      } else if (aug === AugmentIds.JAILER) {
        const rt = store.getRuntime(event.attackerUnitId);
        if (!rt.usedOnce) {
          rt.usedOnce = true;
          if (event.victimType !== 'k') {
            store.queueBenchNextRound(pieceTypeToWhite(event.victimType));
          }
        }
      }
      break;
    }
    case 'onCheck': {
      const aug = store.getAugmentId(event.attackerUnitId);
      if (aug === AugmentIds.TAXMAN) {
        const rt = store.getRuntime(event.attackerUnitId);
        if (!rt.usedOnce) { rt.usedOnce = true; store.addGold(2); }
      }
      break;
    }
    case 'onGameEnd': {
      if (event.deliveredByUnitId) {
        const aug = store.getAugmentId(event.deliveredByUnitId);
        if (aug === AugmentIds.EXECUTIONER) store.addGold(8);
      }
      payoutBountyHunter(store);
      payoutPathfinder(store);
      // Scrapper handled via captured registry if implemented later
      break;
    }
    case 'onSurvive': {
      const aug = store.getAugmentId(event.unitId);
      if (aug === AugmentIds.VETERAN) store.addGold(1);
      if (aug === AugmentIds.RECRUITER) store.queueBenchNextRound('wP');
      break;
    }
    case 'onRoundStart': {
      resetRoundAccruals(store);
      // Crown Tax static income
      if (store.kingHas && store.kingHas(AugmentIds.CROWN_TAX)) store.addGold(2);
      // Demagogue: if white has more pawns than black, +$2 and +1 pawn queued
      try {
        if (store.kingHas && store.kingHas(AugmentIds.DEMAGOGUE) && store.getPawnCounts) {
          const counts = store.getPawnCounts();
          if (counts && typeof counts.white === 'number' && typeof counts.black === 'number') {
            if ((counts.white || 0) > (counts.black || 0)) {
              store.addGold(2);
              store.queueBenchNextRound('wP');
            }
          }
        }
      } catch (_) {}
      break;
    }
    default:
      break;
  }
}

function resetRoundAccruals(store) {
  if (!store.forEachWhiteUnit) return;
  store.forEachWhiteUnit((unitId) => {
    const aug = store.getAugmentId(unitId);
    if (!aug) return;
    const rt = store.getRuntime(unitId);
    if (aug === AugmentIds.BOUNTY_HUNTER) rt.bountyPending = 0;
    if (aug === AugmentIds.PATHFINDER) rt.tilesMoved = 0;
  });
}

function payoutBountyHunter(store) {
  if (!store.forEachWhiteUnit) return;
  store.forEachWhiteUnit((unitId) => {
    if (store.getAugmentId(unitId) !== AugmentIds.BOUNTY_HUNTER) return;
    const rt = store.getRuntime(unitId);
    const gold = Math.min(2, rt.bountyPending || 0);
    if (gold > 0) store.addGold(gold);
    rt.bountyPending = 0;
  });
}

function payoutPathfinder(store) {
  if (!store.forEachWhiteUnit) return;
  store.forEachWhiteUnit((unitId) => {
    if (store.getAugmentId(unitId) !== AugmentIds.PATHFINDER) return;
    const rt = store.getRuntime(unitId);
    const tiles = rt.tilesMoved || 0;
    const gold = Math.min(3, Math.floor(tiles / 10));
    if (gold > 0) store.addGold(gold);
    rt.tilesMoved = 0;
  });
}

function pieceTypeToWhite(t) {
  const m = String(t || '').toLowerCase();
  if (m === 'p') return 'wP';
  if (m === 'n') return 'wN';
  if (m === 'b') return 'wB';
  if (m === 'r') return 'wR';
  if (m === 'q') return 'wQ';
  return null;
}

function manhattan(from, to) {
  try {
    const fx = from.charCodeAt(0) - 97;
    const fy = parseInt(from[1], 10) - 1;
    const tx = to.charCodeAt(0) - 97;
    const ty = parseInt(to[1], 10) - 1;
    return Math.abs(fx - tx) + Math.abs(fy - ty);
  } catch (_) {
    return 0;
  }
}


